<template>
  <div class="rotation-info app-region blank-t-v blank-b-v blank-l-h blank-r-h">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol" >
      <a-form-model-item label="费项科目" prop="name">
        <a-input v-model="form.name" placeholder="请输入费项科目" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="发布社区" prop="community">
        <a-select mode="multiple" v-model="form.community" placeholder="请选择发布社区" :disabled="!!id || !isPlatformRole">
          <a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="收费类型" prop="type">
        <a-select :disabled="isDefault" v-model="form.type" placeholder="请选择收费类型">
          <a-select-option :value="value.id" v-for="value in typeOptions" :key="value.id">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="收费公式" prop="formula">
        <a-select :disabled="isDefault" v-model="form.formula" placeholder="请选择收费公式">
          <a-select-option :value="value.id" v-for="value in formulaOptions" :key="value.id">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="单价" prop="price">
        <a-input-number v-model="form.price" placeholder="请输入单价" allow-clear :min="0"></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="计费周期" prop="paymentCycle">
        <a-select v-model="form.paymentCycle" placeholder="请选择计费周期">
          <a-select-option :value="1">{{paymentCycleStatusText(1)}}</a-select-option>
          <a-select-option :value="2">{{paymentCycleStatusText(2)}}</a-select-option>
          <a-select-option :value="3">{{paymentCycleStatusText(3)}}</a-select-option>
          <a-select-option :value="4">{{paymentCycleStatusText(4)}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="出账日期" prop="statementDateOne" v-if="form.paymentCycle === 1">
        <a-select v-model="form.statementDateOne" placeholder="请选择出账日期">
          <a-select-option :value="`${value}`" v-for="value in 28" :key="value">每月{{value}}日</a-select-option>
          <a-select-option value="last">每月最末1日</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="出账日期" prop="statementDateTwo" v-else-if="form.paymentCycle === 2">
        <a-select v-model="form.statementDateTwo" placeholder="请选择出账日期">
          <a-select-option value="first">每季第1日</a-select-option>
          <a-select-option value="last">每季最末1日</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="出账日期" prop="statementDateThree" v-else>
        <a-date-picker v-model="form.statementDateThree" placeholder="请选择出账日期" valueFormat="YYYY-MM-DD"></a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="滞纳金" prop="lateFee">
        <a-radio-group v-model="form.lateFee">
          <a-radio :value="1">有</a-radio>
          <a-radio :value="0">无</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <template v-if="form.lateFee">
        <a-form-model-item label="滞纳金比例（%）" prop="lateFeePercent">
          <a-input-number v-model="form.lateFeePercent" placeholder="请输入滞纳金比例" allow-clear></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="滞纳金计算周期" prop="caculatePeriod">
          <a-select v-model="form.caculatePeriod" placeholder="请选择滞纳金计算周期">
            <a-select-option :value="1">{{caculatePeriodStatusText(1)}}</a-select-option>
            <a-select-option :value="2">{{caculatePeriodStatusText(2)}}</a-select-option>
            <a-select-option :value="3">{{caculatePeriodStatusText(3)}}</a-select-option>
            <a-select-option :value="4">{{caculatePeriodStatusText(4)}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="滞纳金开始计算时间" prop="startDay">
          <a-space>
            <span>出账单日后第</span>
            <a-input-number v-model="form.startDay" placeholder="请输入" allow-clear></a-input-number>
            <span>天</span>
          </a-space>
        </a-form-model-item>
      </template>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
  import {
    paymentCycleStatusText,
    caculatePeriodStatusText
  } from '@/io/dict.js';
  import CommunityService from '@/io/community.js';
  import ChargeTypeService from '@/io/charge_type.js';
  import FormulaService from '@/io/formula.js';
  import ExpendService from '@/io/expend.js';

  export default {
    data() {
      return {
        paymentCycleStatusText,
        caculatePeriodStatusText,
        id: this.$route.params.id,
        communityOptions: [],
        typeOptions: [],
        formulaOptions: [],
        isDefault: false, // 默认数据不可编辑
        form: {
          name: null,
          community: [],
          type: [],
          formula: [],
          price: null,
          paymentCycle: [],
          statementDateOne: [],
          statementDateTwo: [],
          statementDateThree: null,
          lateFee: null,
          lateFeePercent: null,
          caculatePeriod: [],
          startDay: null
        },
        rules: {
          name: [
            {
              required: true,
              message: "请输入费项科目",
            },
          ],
          community: [
            {
              required: true,
              message: "请选择发布社区",
            },
          ],
          type: [
            {
              required: true,
              message: '请选择收费类型'
            },
          ],
          formula: [
            {
              required: true,
              message: "请选择收费公式",
            },
          ],
          price: [
            {
              required: true,
              message: "请填写单价",
            },
          ],
          paymentCycle: [
            {
              required: true,
              message: '请选择计费周期'
            },
          ],
          statementDateOne: [
            {
              required: true,
              message: "请选择出账日期",
            },
          ],
          statementDateTwo:[
            {
              required: true,
              message: '请选择出账日期'
            },
          ],
          statementDateThree:[
            {
              required: true,
              message: '请选择出账日期'
            },
          ],
          lateFee:[
            {
              required: true,
              message: '请选择滞纳金'
            },
          ],
          lateFeePercent:[
            {
              required: true,
              message: '请填写滞纳金比例'
            },
          ],
          caculatePeriod:[
            {
              required: true,
              message: '请选择滞纳金计算周期'
            },
          ],
          startDay:[
            {
              required: true,
              message: '请选择滞纳金开始计算周期'
            },
          ],
        },
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          Promise.all([
            this.initCommunity(),
            this.initType()
          ]).then(() => {
            this.initPage();
          });
        },
        immediate: true,
      },
      'form.type': {
        handler(newValue, oldValue) {
          if (newValue) {
            this.initFormula();
          }
        },
        immediate: true,
      }
    },
    methods: {
      initPage() {
        if (this.$getCookie('communityId')) {
          this.form.community = [this.$getCookie('communityId') * 1];
        }
        if (this.id) {
          ExpendService.info(this.id).then(res => {
            console.log(res,444)
            this.isDefault = !!res.is_default;
            this.form.name = res.name;
            this.form.community = res.community_ids;
            this.form.type = res.expenses_type_id;
            this.form.formula = res.formula_id;
            this.form.price = res.price;
            this.form.paymentCycle = res.billing_cycle_type;
            if (res.billing_cycle_type === 1) {
              this.form.statementDateOne = res.billing_cycle_date;
            } else if (res.billing_cycle_type === 2) {
              this.form.statementDateTwo = res.billing_cycle_date;
            } else if (res.billing_cycle_type === 3) {
              this.form.statementDateThree = `${new Date().getFullYear()}-${res.billing_cycle_date}`;
            } else {
              this.form.statementDateThree = res.billing_cycle_date;
            }
            this.form.lateFee = res.has_late_fee;
            this.form.lateFeePercent = res.late_fee_percent;
            this.form.caculatePeriod = res.late_fee_cycle;
            this.form.startDay = res.late_fee_start_day;
          });
        }
      },
      initCommunity() {
        return CommunityService.listPage().then((res) => {
          this.communityOptions = res;
        }).catch((err) => {});
      },
      initType() {
        return ChargeTypeService.list().then(res => {
          this.typeOptions = res;
        }).catch(err => {});
      },
      initFormula() {
        return FormulaService.list(this.form.type).then(res => {
          this.formulaOptions = res;
        }).catch(err => {});
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.id) {
            ExpendService.edit(
              this.id,
              this.form.name,
              this.form.community,
              this.form.type,
              this.form.formula,
              this.form.price,
              this.form.paymentCycle,
              this.form.paymentCycle === 1 ? this.form.statementDateOne : (this.form.paymentCycle === 2 ? this.form.statementDateTwo : (this.form.paymentCycle === 3 ? this.form.statementDateThree.substring(5) : this.form.statementDateThree)),
              this.form.lateFee,
              this.form.lateFeePercent,
              this.form.caculatePeriod,
              this.form.startDay
            ).then((res) => {
              this.$afterFormSubmit('编辑成功', () => {
                this.cancel();
              });
            }).catch((err) => {});
          } else {
            ExpendService.add(
              this.form.name,
              this.form.community,
              this.form.type,
              this.form.formula,
              this.form.price,
              this.form.paymentCycle,
              this.form.paymentCycle === 1 ? this.form.statementDateOne : (this.form.paymentCycle === 2 ? this.form.statementDateTwo : (this.form.paymentCycle === 3 ? this.form.statementDateThree.substring(5) : this.form.statementDateThree)),
              this.form.lateFee,
              this.form.lateFeePercent,
              this.form.caculatePeriod,
              this.form.startDay
            ).then((res) => {
              this.$afterFormSubmit('创建成功', () => {
                this.cancel();
              });
            }).catch((err) => {});
          }

        });
      },
      cancel() {
        this.$router.push({
          name: 'ExpendManage'
        });
      },
    },
  };
</script>

<style lang="less" scoped>

</style>